import axios from 'axios';
import qs from 'qs';
import clairvoyanceRecordFinish from '@/utils/basicConfig/clairvoyanceRecord';
import bus from '@/utils/basicConfig/bus.js';
import Cookies from 'js-cookie';
const successReturnCode = ['00', '0000', '1', '1048', '1070', '1042']; //接口请求成功状态码 returnCode
const successCode = [1]; //接口请求成功状态码 code
const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
};
var instance = axios.create({
  baseURL: '/api', // 默认前缀
  timeout: 180000, // 请求超时
  headers: {
    'X-Custom-Header': 'foobar',
    'Content-Type': 'application/json'
  }
});
// Add a request interceptor
instance.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    if (config.method.toLowerCase() === 'post' && config.data && config.data.formEncode) {
      //post请求 格式化数据
      config.data = qs.stringify(config.data);
    }

    if (Cookies.get('token')) {
      //携带登录cookie
      config.headers.authorization = Cookies.get('token');
    }
    
    bus.$emit('show-loading'); //接口请求遮罩
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
const errorHandler = error => {
  const { response = {} } = error;
  const errortext = codeMessage[response.status] || response.statusText; // 错误提示信息
  const { status } = response;
  if (status === 401) {
    window.$msg.error({
      message: '未登录或登录已过期，请重新登录。'
    });
    bus.$emit('showLogin', true);
    return;
  }
  if (!status) {
    return;
  }
  window.$msg.error({
    message: `请求错误 ${status}: ${error.config.url}`,
    description: errortext
  });
};
// Add a response interceptor
instance.interceptors.response.use(
  function(response) {
    bus.$emit('hide-loading');
    // Do something with response data
    const { returnCode, returnMsg, code, message, error } = response.data;
    if (successReturnCode.indexOf(returnCode) < 0 && successCode.indexOf(code) < 0) {
      window.message.error(returnMsg || message || error, 3);
      return Promise.reject(response);
    }
    try {
      //结束录制
      clairvoyanceRecordFinish.end(response); //结束录制
    } catch (error) {
      console.log(error);
    }
    return response;
  },
  function(error) {
    bus.$emit('hide-loading');
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      errorHandler(error);
    } else {
      // Something happened in setting up the request that triggered an Error
      
      // 超时提示
      // if(error.message.includes('timeout')) {
      //   if(response.config.url.indexOf('/policy/guofu/employerPolicy')) {

      //   }
      // }
      window.message.error(error.message);
    }
    // Do something with response error
    return Promise.reject(error);
  }
);
export default instance;
